import { render, staticRenderFns } from "./DropdownOption.vue?vue&type=template&id=89dc7360&scoped=true"
import script from "./DropdownOption.vue?vue&type=script&lang=js"
export * from "./DropdownOption.vue?vue&type=script&lang=js"
import style0 from "./DropdownOption.vue?vue&type=style&index=0&id=89dc7360&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89dc7360",
  null
  
)

export default component.exports